import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-VF-logo_svg__Layer_2",
  "data-name": "Layer 2",
  viewBox: "0 0 46 49.04"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-VF-logo_svg__cls-1{fill:#008fda}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      d: "M45.99 11.83c0-3.75-2.82-6.89-3.73-7.81C41.35 3.09 38.27 0 38.27 0v33.36c0 3.75 2.82 6.89 3.73 7.81.91.93 3.99 4.02 3.99 4.02V11.83ZM32.61 16.48c2.66-2.65 2.89-6.86 2.9-8.15 0-1.3.03-5.66.03-5.66L2.93 35.19C.28 37.84.04 42.05.03 43.34.03 44.64 0 49 0 49l32.61-32.52Z",
      class: "svg-VF-logo_svg__cls-1"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M32.61 16.48c2.66-2.65 2.89-6.86 2.9-8.15 0-1.3.03-5.66.03-5.66L2.93 35.19C.28 37.84.04 42.05.03 43.34.03 44.64 0 49 0 49l32.61-32.52ZM32.15 46.12c2.66 2.65 6.88 2.88 8.18 2.89s5.67.03 5.67.03L33.2 36.27c-2.66-2.65-6.87-2.88-8.18-2.9-1.3 0-5.67-.03-5.67-.03l12.8 12.77Z",
      class: "svg-VF-logo_svg__cls-1"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "VF-logo"}) } }